import script from "./ProductSpotSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSpotSwiper.vue?vue&type=script&setup=true&lang=ts"

import "./ProductSpotSwiper.vue?vue&type=style&index=0&id=48ea5356&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ea5356"]])

export default __exports__